import { Languages } from 'lucide-react';
import { LOCALES, LOCALE_META, type Locale } from '@/brand/i18n';
import { useLocale } from '@/i18n/locale-provider';

/**
 * Switches the interface language.
 *
 * The label is always written in the language being switched *to*, so it is legible to
 * someone who cannot read the current one — the one control that must never be localised
 * into a language the reader may not have.
 */
export function LanguageToggle({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  const { locale, setLocale } = useLocale();
  const other = (LOCALES.find((candidate) => candidate !== locale) ?? locale) as Locale;
  const meta = LOCALE_META[other];

  return (
    <button
      type="button"
      onClick={() => setLocale(other)}
      lang={other}
      aria-label={`Switch to ${meta.englishName}`}
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-2 text-sm font-medium
                  transition-colors ${
                    tone === 'dark'
                      ? 'text-mist-400 hover:bg-deep-800 hover:text-white'
                      : 'text-mist-600 hover:bg-mist-100 hover:text-deep-700'
                  }`}
    >
      <Languages size={16} aria-hidden />
      <span>{meta.nativeName}</span>
    </button>
  );
}
